import { IonIcon, IonItem, IonText } from "@ionic/react";
import { useAppContext, useAppContextUpdater } from "../../services/app-context.service";
import { airplane, document, person, power } from "ionicons/icons";
import loginService from "../../services/loginService";
import { authModalRef } from "./AuthModal";
import { appSubDir } from "../../configs/app";
import { faDashboard } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const UserMenu: React.FC = () => {
    const appData = useAppContext();
    const isAdmin = appData.user.roles?.includes("admin");
    const setAppData = useAppContextUpdater();

    const handleDismiss = () => {
        authModalRef.current?.dismiss();
    };

    return (
        <div id="profile-menu">
            <IonItem routerLink={appSubDir + "profile"} onClick={handleDismiss}>
                <IonIcon slot="start" icon={person} />
                <IonText>Update Profile</IonText>
            </IonItem>

            {isAdmin && (
                <IonItem routerLink={appSubDir + "admin/dashboard"} onClick={handleDismiss}>
                    <IonText slot="start" style={{ color: "rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.54)" }}>
                        <FontAwesomeIcon fontSize={22} icon={faDashboard} />
                    </IonText>
                    <IonText>Admin Panel</IonText>
                </IonItem>
            )}

            <IonItem routerLink={appSubDir + "invoices"} onClick={handleDismiss}>
                <IonIcon slot="start" icon={document} />
                <IonText>{isAdmin ? "All Orders" : "My Invoices"}</IonText>
            </IonItem>

            <IonItem routerLink={appSubDir + "my-bookings"} onClick={handleDismiss}>
                <IonIcon slot="start" icon={airplane} />
                <IonText>My Shipping Bookings</IonText>
            </IonItem>

            <IonItem routerLink={appSubDir + "create-booking"} onClick={handleDismiss}>
                <IonIcon slot="start" icon={airplane} />
                <IonText>Book Shipping Service</IonText>
            </IonItem>

            <IonItem
                button={true}
                onClick={() => {
                    loginService.doLogOut().then(() => {
                        authModalRef.current?.dismiss();
                        setAppData({ ...appData, user: loginService.currentUser });
                    });
                }}
            >
                <IonIcon slot="start" icon={power} style={{ color: '#e11d48' }} />
                <IonText style={{ color: '#e11d48' }}>Logout</IonText>
            </IonItem>
        </div>
    );
};

export default UserMenu;
